<template>
  <main>
    <div class="box">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: './' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: './orderCenter' }">订单列表</el-breadcrumb-item>
        <el-breadcrumb-item>订单详情</el-breadcrumb-item>
      </el-breadcrumb>
      <section class="detail">
        <h3>订单详情</h3>
        <ul>
          <li><span>订单号：</span><b class="main">{{ orderInfo.order_sn }}</b></li>
          <li><span>订单状态：</span><b>{{ orderInfo.status_label }}</b></li>
          <li><span>联系人：</span><b>{{ orderInfo.contact_name }}</b></li>
          <li><span>联系电话：</span><b>{{ orderInfo.contact_phone }}</b></li>
          <li><span>创建时间：</span><b>{{ orderInfo.created_at }}</b></li>
          <li><span>出行日期：</span><b class="bold">{{ orderInfo.sku_travel_date }}</b></li>
          <li><span>备注：</span><b>{{ orderInfo.remark || '--' }}</b></li>

        </ul>
        <el-table :data="table">
          <el-table-column prop="spu_name" label="产品名称"></el-table-column>
          <el-table-column prop="sku_name" label="套餐"></el-table-column>
          <el-table-column align="center" prop="sku_quantity" label="办理人数"></el-table-column>
          <el-table-column align="center" label="套餐价格">
            <template slot-scope="s">
              <span class="bold">{{ s.row.sku_price }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="其他费用">
            <template slot-scope="s">
              <span class="bold">{{ s.row.extra_price }}</span>
            </template>
          </el-table-column>
        </el-table>

        <!-- 办理信息模块内容 -->

        <div class="extendedInfoWrap" v-if="show_extended_info && show_extended_info.length">
          <div class="defaultTitle">办理信息
            <div class="editrequiredFormDataBtn" @click="editFieldFormData">编辑办理信息</div>
          </div>

          <div class="extendedItem" v-for="(item, index) in show_extended_info" :key="index">
            {{ item.label }}：
            <p>{{ item.value }}</p>
          </div>

        </div>

        <div class="price">
          <div class="link">
            <router-link :to="{ name: 'order_payment', query: { order_sn: orderInfo.order_sn } }"
              v-if="orderInfo.payment_status == 'B' && orderInfo.status == 'P'">去支付</router-link>
            <div class="cancelOrder" @click="cancelOrder(orderInfo.order_sn)" v-if="orderInfo.status != 'C'">取消订单</div>
          </div>
          <p><span>实付金额：</span><b>{{ orderInfo.order_price }}</b></p>
        </div>
      </section>

      <edit-order-field-form ref="editOrderFieldForm" @UpdateFieldForm="UpdateFieldForm"></edit-order-field-form>
    </div>
  </main>
</template>

<script>
import $orderPro from '@api/orderPro';
import tool from '@assets/js/tool';
import editOrderFieldForm from './component/editOrderFieldForm';
import { Loading } from 'element-ui';

export default {
  components: {
    editOrderFieldForm
  },
  data() {
    return {
      orderInfo: {},//订单详细内容
      table: [],
      show_extended_info: [],//办理信息
      requireFieldOption: [], //办理信息 编辑内容
    }
  },
  created() {
    const { order_sn } = this.$route.query;
    // if ( !OrderNO ) {
    //   this.$router.push({ name: 'order_list' });
    //   return;
    // }
    this.getDetail(order_sn);


  },
  filters: {
    getInsDate(info) {
      const { BeginDate, EndDate } = info.visa_order_ins;
      return `${BeginDate} ~ ${EndDate}`;
    },
    getPaidDesc(type) {
      const desc = ['待付款', '已付款', '部分付款'];
      return desc[type] || type || null;
    },
    getAddress(item) {
      const {
        class_id,
        m_pro, m_city, m_area, m_address,
        r_pro, r_city, r_area, r_address
      } = item;
      return `${class_id === 165 ? m_pro + m_city + m_area + m_address : r_pro + r_city + r_area + r_address}`
    }
  },
  methods: {
    // 监听子组件更新办理信息内容
    UpdateFieldForm() {
      let _this = this;

      this.loadingInstance = Loading.service({
        text: '加载中...',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      this.getDetail(this.orderInfo.order_sn);
      setTimeout(() => {
        _this.loadingInstance.close();
      }, 600);
    },
    // 取消订单
    cancelOrder(order_sn) {
      let _this = this;
      this.$prompt('请输入取消订单的理由', '取消订单', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
      }).then(async ({ value }) => {
        const requestData = {
          order_sn,
          reason: value
        }
        // 调用取消订单接口
        await $orderPro.cancelOrderByOrderSn(requestData).then((res) => {
          if (res.status == 'success') {
            _this.$message({
              type: 'success',
              message: res.message
            });
            setTimeout(() => {
              _this.$router.push({ name: 'orderCenter' });
            }, 1500);
          } else {
            _this.$message({
              type: 'info',
              message: res.message
            });
          }
        })
      }).catch((err) => {

      });
    },
    // 编辑办理信息
    editFieldFormData() {
      const order_sn = this.orderInfo.order_sn;
      this.$refs.editOrderFieldForm.openEditForm(order_sn, this.requireFieldOption, this.orderInfo.sku_travel_date);
    },
    // 通过ID获取订单详情
    getDetail(order_sn) {
      let _this = this;
      $orderPro.getOrderDetailByOrdersn(order_sn).then((res) => {
        res.data.sku_price = tool.ConversionPrice(res.data.sku_price)
        res.data.order_price = tool.ConversionPrice(res.data.order_price)
        res.data.extra_price = res.data.extra_price ? tool.ConversionOtherPrice(res.data.extra_price) : 0

        const show_extended_info = res.data.show_extended_info || null;

        if (show_extended_info) {
          const sortData = tool.sortByKey(show_extended_info, "sort");
          _this.show_extended_info = sortData;
        }

        if (res.data.extra_application_mandatory_fields && res.data
          .extra_application_mandatory_fields.length) {
          _this.getOrderFieldOptions(res.data.sku_id, res.data.src_extended_info); //获取下单必填表单数据信息								
        }

        _this.orderInfo = res.data;
        _this.table = [res.data];

      });

    },
    // 获取并设置 办理信息编辑内容
    getOrderFieldOptions(sku_id, editForm) {
      let _this = this;
      $orderPro.getOrderFieldOptions(sku_id).then((res) => {
        if (res.status == "success") {
          let DeepFormOption = JSON.parse(JSON.stringify(res.data));

          for (let i in editForm) {
            DeepFormOption.map((item) => {
              if (item.field_name == i) {
                item.form_value = editForm[i];
                item.currentShowValue = editForm[i];
                if (item.input_type == "select") {
                  const targets = item.data_sources.find((item) => item
                    .value == editForm[i]);
                  if (targets && Object.keys(targets)) {
                    item.selectedLabel = targets.label;
                    item.currentShowValue = targets.label;
                  }
                }
              }

            })
          }
          _this.requireFieldOption = DeepFormOption;
        }
      })
    }
  }
}
</script>

<style scoped src="./orderDetail.css"></style>